
import React            from 'react';
import portrait         from './portrait.module.css';
import landscape        from './money.module.css';
import Newspaper        from '../components/Newspaper.jsx';
import Newspaper_4_col  from '../components/Newspaper_4_col.jsx';
import Paper            from '../components/Paper.jsx';
import pic_museum       from '../pictures/Bank notes in Museum.webp';
import { Context }      from '../services/context.js';
import { Helmet }       from 'react-helmet';
import cx               from 'classnames';
import pic_money        from '../pictures/money concept.avif';
import burn_banknotes   from '../pictures/Burning Banknotes.avif';
import money_disks      from '../pictures/Disks_Toshiba.avif';
import money_shredder   from '../pictures/Money Shredder.avif';

const cx_title  = cx({[portrait.title]:  Context.portrait, [landscape.title]:   !Context.portrait});
const cx_header = cx({[portrait.header]: Context.portrait, [landscape.header]:  !Context.portrait});
const cx_text   = cx({[portrait.text]:   Context.portrait, [landscape.text]:    !Context.portrait});
const cx_ul     = cx({[portrait.ul]:     Context.portrait, [landscape.ul]:      !Context.portrait});
const cx_li     = cx({[portrait.li]:     Context.portrait, [landscape.li]:      !Context.portrait});

export class Money extends React.Component 
{
  constructor(props) {
    super(props);
    this.state = {content_disabled: false}
  }

  componentDidMount() 
  {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }

  //------------------------------------------------------------------
  //
  //------------------------------------------------------------------
  changeVisible(mode)
  {
    this.setState({content_disabled:mode})
  }

  render() 
  {
    // Text arrays with corrected English

    //--------------------------------------------------------------------------------------
    //
    //--------------------------------------------------------------------------------------
    const text_1 = [
      {
        header: (
          <p className={cx_header}>
            The Challenges of Electronic Currencies
          </p>
        )
      },
      {
        text: (
          <p className={cx_text}>
            Despite the proliferation of digital currencies, many aren’t true currencies but products driven by supply and demand. Such dynamics create an illusion of easy wealth, fueled by limited initial supply and aggressive marketing. While early investors may profit, the cycle of addiction that follows is unsustainable. Extreme volatility also makes cryptocurrencies impractical for everyday purchases—buying a baguette with Bitcoin, for example, is fraught with challenges, so most merchants avoid crypto payments. Integrating digital currencies on Back‑Step Blockchain could solve these issues. In another article, we explore how a Back‑Step Blockchain–based currency might transform daily life.
          </p>
        )
      }
    ];
    
    const text_2 = [
      {
        header: (
          <p className={cx_header}>
            Should We Support Crime?
          </p>
        )
      },
      {
        text: (
          <p className={cx_text}>
            The anonymity of many cryptocurrencies has made them a tool for illicit activities. Although widely recognized, only a few jurisdictions—like China—have taken decisive action. Unlike crypto, fiat currencies aren’t anonymous: each banknote’s serial number can be traced (with AI image tools). Fiat is also confined by geography, complicating cross‑border crime. These factors drive criminal preference for crypto. It’s essential to implement measures that curb these abuses.
          </p>
        )
      }
    ];
    
    const text_3 = [
      {
        header: (
          <p className={cx_header}>
            Money for Modern Times
          </p>
        )
      },
      {
        text: (
          <p className={cx_text}>
            Back‑Step Blockchain unlocks groundbreaking possibilities for electronic money, surpassing legacy cryptocurrencies. We outline an architecture for designing an e‑currency on our advanced platform. Today, we still rely on paper notes and metal coins—now it’s time for change. A blockchain system can keep your money safe and reliable. Leading countries like Singapore already manage massive data volumes. By leveraging modern innovations, everyone saves time and money. We invite nations, experts, and forward‑thinking designers to collaborate. Traditional blockchains suffer slow speeds and high costs, preventing real‑time payments. A successful digital currency must benefit all users—residents, visitors, and exclude illicit actors. Automated foreign exchange and configurable interest (positive or negative) are also possible.
          </p>
        )
      },
      {
        header: (
          <p className={cx_header}>
            Architecture of an Electronic Currency
          </p>
        )
      },
      {
        text: (
          <p className={cx_text}>
            From here on, it gets technical. The main idea is to store all currency in a few large blockchain systems instead of individual wallets—a setup previously impossible due to slow speeds, high costs, and limited capacity. With Back‑Step Blockchain, these obstacles no longer exist. Our solution uses two chains: an <b>inventory chain</b> and a <b>transaction chain</b>. The inventory chain logs all issued money‑blocks (equivalent to banknotes and coins). When issuing currency, authorities generate unique IDs, sign them with private keys, and append them to the inventory chain, creating a transparent, verifiable ledger. The transaction chain records every payment—each money‑block transfer, timestamp, sender, and receiver—ensuring traceability and privacy. Users interact with a host–virtual model, seeing only their own balance and history.
          </p>
        )
      }
    ];
    
    const text_4 = [
      {
        header: (
          <p className={cx_header}>
            Feasibility Study – Inventory Chain
          </p>
        )
      },
      {
        text: (
          <p className={cx_text}>
            We calculated requirements—speed and size—for Singapore’s inventory chain. Future shopping made easy!
          </p>
        )
      },
      {
        text: (
          <ul className={cx_ul}>
            <li className={cx_li}>
              <strong>Inventory Chain Size:</strong> Each block is <b>2,976 bytes</b>, including a post‑quantum CRYSTALS‑Dilithium certificate and metadata.
            </li>
            <li className={cx_li}>
              <strong>Money‑Blocks Required:</strong> ~<b>3 billion</b> blocks to cover denominations from SGD 0.10 to SGD 10,000.
            </li>
            <li className={cx_li}>
              <strong>Storage Capacity:</strong> 3 billion × 2,976 bytes ≈ 8.93 × 10<sup>12</sup> bytes (less than 10 TB)—trivial for Back‑Step Blockchain.
            </li>
            <li className={cx_li}>
              <strong>Initial Signing Time:</strong> less than 1 hour on a custom chip/CPU; 10–15 hours on FPGA.
            </li>
            <li className={cx_li}>
              <strong>Write Time:</strong> A 64‑core, 512 GB RAM server with ZFS (2 parity, 4 data disks) writes all blocks in less than 3 hours.
            </li>
            <li className={cx_li}>
              <strong>Block Generation Speed:</strong> Up to 100 million blocks/sec on chip; 100,000 blocks/sec on FPGA—full chain in ≤ 15 hours.
            </li>
          </ul>
        )
      }
    ];
    
    const text_5 = [
      {
        header: (
          <p className={cx_header}>
            Feasibility Study – Transactions
          </p>
        )
      },
      {
        text: (
          <p className={cx_text}>
            The transaction chain must handle real‑time payments. Can we manage the load and storage? We answer with ChatGPT and DepSeek R1. Each payment consumes one block; change may use two. A single acknowledgment is returned. When exact change isn’t available, multiple notes fit into one block thanks to variable payload size—e.g., seven notes in one block incur a single fee. Paying SGD 185 with two SGD 100 blocks triggers automated change distribution (one SGD 10, one SGD 5 block). Our server software optimizes change per user profile, so merchants never run out of change.
          </p>
        )
      }
    ];
    
    const text_6 = [
      {
        header: (
          <p className={cx_header}>
            The Framework for Transactions
          </p>
        )
      },
      {
        text: (
          <ul className={cx_ul}>
            <li className={cx_li}>
              <strong>Assumptions:</strong> 6.1 million Singapore residents make 30 payments/day (10,950 per person/year) → 66.795 billion annual transactions.
            </li>
            <li className={cx_li}>
              <strong>Visitor Load:</strong> 17 million visitors × 4 days × 40 payments/day → 2.72 billion transactions.
            </li>
            <li className={cx_li}>
              <strong>Total Annual Tx:</strong> ~69.515 billion.
            </li>
            <li className={cx_li}>
              <strong>Storage Needs:</strong> 320 bytes fixed + 16 bytes/note. With 13 notes, block size = 528 bytes → ≈38.14 TB/year (and growing).
            </li>
            <li className={cx_li}>
              <strong>Peak Throughput:</strong> 6,613 tx/sec (300% headroom).
            </li>
          </ul>
        )
      },
      {
        text: (
          <p className={cx_text}>
            These figures show Back‑Step Blockchain easily handles transaction volumes—even for populations 200× Singapore’s.
          </p>
        )
      }
    ];
    
    const text_7 = [
      {
        header: (
          <p className={cx_header}>
            The Transition to Electronic Currency
          </p>
        )
      },
      {
        text: (
          <p className={cx_text}>
            Implementation can be incremental: convert fiat notes into money‑blocks via authorized banks. Each note is checked against the inventory chain—duplicates are rejected; new notes become blocks. Physical notes can then be destroyed or kept as souvenirs.
          </p>
        )
      },
      {
        text: (
          <p className={cx_text}>
            During transition, participants enroll in the system. Authorized providers (banks) invest minimal effort and gain long‑term benefits—e.g., selling ATM machines. This phased approach leads to a future without minting or ATM queues.
          </p>
        )
      },
      {
        text: (
          <p className={cx_text}>
            Feedback, proposals, and ideas are welcome.
          </p>
        )
      }
    ];
    
    const text_8 = [
      {
        header: (
          <p className={cx_header}>
            Win‑Win for All Parties
          </p>
        )
      },
      {
        text: (
          <p className={cx_text}>
            Electronic money should make everyday transactions as simple as credit cards. Merchants save on fees with Back‑Step Blockchain’s low rates. Consumers can pay per transaction or merchants may cover fees—either way, everyone benefits.
          </p>
        )
      },
      {
        text: (
          <p className={cx_text}>
            <strong>Users benefit:</strong>
            <ul className={cx_ul}>
              <li className={cx_li}>Funds cannot be lost.</li>
              <li className={cx_li}>Money cannot be stolen.</li>
              <li className={cx_li}>Double‑spending is impossible.</li>
              <li className={cx_li}>No time wasted counting cash.</li>
              <li className={cx_li}>Simplified finances—no ATM lines.</li>
              <li className={cx_li}>Lower fees: banks charge ~0.50 SGD/txn, Back‑Step charges one block fee.</li>
              <li className={cx_li}>No need to carry cash.</li>
            </ul>
          </p>
        )
      },
      {
        text: (
          <p className={cx_text}>
            On average, a Singapore user generates ~40 MB of chain data per year. All computation runs on central servers; users can download their virtual chain to smartphones for real‑time spending overviews.
          </p>
        )
      }
    ];
    

    //--------------------------------------------------------------------------------------
    // Render different layouts based on the orientation (portrait vs. landscape)
    //--------------------------------------------------------------------------------------
    if (Context.portrait) 
    {
      return (
        <div className={portrait.backdrop}>
          <Helmet>
            <title>Money Apps with Back-Step Blockchain</title>
            <meta name="description" content="Explains new opportunities for financial applications and better crypto money." />
            <meta charSet="utf-8" />
          </Helmet>

          <div className={cx_title}>
            Money turns the world around
          </div>

          <div>
            <Paper textLines={text_1} />
          </div>

          <div>
            <Paper textLines={text_2} />
          </div>

          <div className={portrait.image}>
            <img src={pic_museum} width="250" alt="Bank notes in museum" />
            <p className={cx_text} style={{ fontSize: '1rem' }}>
              Parents show their kids how their grandparents paid for goods.
            </p>
          </div>

          <div>
            <Paper textLines={text_3} />
          </div>

          <div className={portrait.image}>
            <img src={pic_money} width="250" alt="Concept of new money" />
            <p className={cx_text} style={{ fontSize: '1rem' }}>
              Conceptual overview of electronic money for a country.
            </p>
          </div>
          
          <div>
            <Paper textLines={text_4} />
          </div>


          <div>
            <Paper textLines={text_5} />
          </div>

          <div className={portrait.image}>
              <img src={burn_banknotes}  alt="Allan Greenspan burning banknotes" />
              <p className={cx_text} style={{ fontSize: '1rem' }}>
              Useless old paper money!
              </p>
           </div>

          <div>
            <Paper textLines={text_6} />
          </div>

          <div className={portrait.image}>
              <img src={money_disks}  alt="Disks containing Singapore's money" />
              <p className={cx_text} style={{ fontSize: '1rem' }}>
                These 3 disks can hold Singapore's money!
              </p>
          </div>

          <div>
            <Paper textLines={text_7} />
          </div>

          <div className={portrait.image}>
              <img src={money_shredder}  alt="Money shredder" />
              <p className={cx_text} style={{ fontSize: '1rem' }}>
                The real shredder looks different. (I have no access)
              </p>
          </div>

          <div>
            <Paper textLines={text_8} />
          </div>

        </div>
      );
    } else {
      return (
        <div className={landscape.backdrop} onMouseDown={()=>this.changeVisible(true)} onMouseUp={()=>this.changeVisible(false)} onContextMenu={(e) => e.preventDefault()}>

          <Helmet>
            <title>Money Apps with Back-Step Blockchain</title>
            <meta name="description" content="Explains new opportunities for financial applications and better crypto money." />
            <meta charSet="utf-8" />
          </Helmet>

          {! this.state.content_disabled &&
          <>
          <div className={landscape.title_location}>
            <div className={landscape.title_text}> 
              <p> The Road to Electronic Money </p>
            </div>
          </div>

          <div className={landscape.container}>



            <div className={landscape.item_left_row_1}>
              <Newspaper textLines={text_1} />
            </div>

            <div className={landscape.item_left_row_2}>
              <Newspaper textLines={text_2} />
            </div>

            <div className={landscape.item_right_row_1}>
              <img src={pic_museum} alt="Bank notes in museum" />
                 <p className={landscape.museum}>Parents show their kids how their grandparents paid for goods.</p>
            </div>

          </div>


          <div className={landscape.container}>

            {/* Money for modern times*/}

            <div className={landscape.item_left_row_1}>
              <Newspaper textLines={text_3} />
            </div>

            <div className={landscape.item_right_row_1}>
              <img className={landscape.image} src={pic_money}  alt="Concept of new money" />
                <p className={landscape.museum}>Conceptual overview of electronic money for a country.</p>
            </div>
          </div>
   
          <div className={landscape.container}>

            <div className={landscape.item_left_row_1}>
              <Newspaper textLines={text_4} />
            </div>

            <div className={landscape.item_left_row_2}>
              <Newspaper textLines={text_5} />
            </div>

            <div className={landscape.item_right_row_1}>
              <img className={landscape.image} src={burn_banknotes}  alt="Allan Greenspan burning banknotes" />
              <p className={landscape.museum}>Useless old paper money!</p>
            </div>

          </div>

          <div className={landscape.container}>

            <div className={landscape.item_left_row_1}>
              <Newspaper textLines={text_6} />
            </div>

            <div className={landscape.item_right_row_1}>
              <img className={landscape.image} src={money_disks}  alt="Disks containing Singapore's money" />
              <p className={landscape.museum}>These 3 disks can hold Singapore's money!</p>
            </div>

          </div>

          <div className={landscape.container}>

            <div className={landscape.item_left_row_1}>
              <Newspaper textLines={text_7} />
            </div>

            <div className={landscape.item_left_row_2}>
              <Newspaper textLines={text_8} />
            </div>

            <div className={landscape.item_right_row_1}>
              <img className={landscape.image} src={money_shredder}  alt="Money shredder" />
              <p className={landscape.museum}>The real shredder looks different. (I have no access)</p>
            </div>

          </div>
          </>
          }
        </div>
      );
    }
  }
}
